import * as types from '../mutation-types'

const state = {
	active: {},
	all: []
}

const mutations = {
	[types.SET_ACTIVE_TANK_GROUP](state, tankGroup) {
		state.active = tankGroup;
	},

	[types.SET_TANK_GROUPS](state, tankGroups) {
		state.all = tankGroups;
	},

	[types.ADD_TANK_GROUP](state, tankGroup) {
		state.all.push(tankGroup);
	},

	[types.DESTROY_TANK_GROUP](state, id) {
		for (let i = 0; i < state.all.length; ++i) {
			if (state.all[i].id == id){
				state.all.splice(i, 1);

				break;
			}
		}
	},

	[types.SET_TANK_GROUP_NAME](state, id, name) {
		for (let i = 0; i < state.all.length; ++i) {
			if (state.all[i].id == id) {
				state.all[i].name = name;

				break;
			}
		}
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tank-groups.js